/* eslint-disable no-shadow */
// TODO [rw-sdk@>=5.0.0]: joel move to rw-sdk.js
enum MicroDepositStatus {
  PendingManual = 'pending_manual_verification',
  PendingAutomatic = 'pending_automatic_verification',
  Manual = 'manually_verified',
  Automatic = 'automatically_verified',
  Unknown = 'UNKNOWN',
}

export default MicroDepositStatus;
